import { LOCAL_STORAGE_KEYS } from 'utils/constants/localStorageKeys';

export const clearAuthDataInLocalStorage = () => {
  localStorage.removeItem(LOCAL_STORAGE_KEYS.ACCESS_TOKEN);
  localStorage.removeItem(LOCAL_STORAGE_KEYS.REFRESH_TOKEN);
  localStorage.removeItem(LOCAL_STORAGE_KEYS.USER);
  localStorage.removeItem(LOCAL_STORAGE_KEYS.SUPER_USER);
};
